import axios from "axios";
import Modal from "react-modal";
import { AES } from 'crypto-js';
import Tooltip from "./Tooltip";
import { DatePicker } from "rsuite";
import moment from 'moment-timezone';
import subDays from "date-fns/subDays";
import { toast } from "react-toastify";
import { DateRangePicker } from "rsuite";
import css from "./InvoiceCreateManual.css";
import { Link, useNavigate } from "react-router-dom";
import { useSelector, useDispatch } from 'react-redux';
import React, { useState, useEffect, useRef, useMemo, useCallback } from "react";
import { AnimatePresence, motion } from "framer-motion";
import { useQueryClient } from "react-query";
import userCategory from "../../../constants/userCategory.js";
import userTypeConsts from "../../../constants/userTypeConsts";
import { logout, reset } from "../../../features/auth/authSlice";
import dletImage from "../../../images/singleinvoice/delete.svg";
import whatis from "../../../images/singleinvoice/whatisthis.svg";
import cancelImage from "../../../images/singleinvoice/cancel.svg";
import crssrImage from "../../../images/singleinvoice/cross-red.svg";
import addicoplus from "../../../images/singleinvoice/plus-add-icon.svg";
import CompanyDocumentField from "../../User/elements/CompanyDocumentField";
import { setHeaderText } from "../../../features/headerText/headerTextSlice";
import { reset as invoiceReset } from "../../../features/invoice/invoiceSlice.js";
import { reset as headerReset } from "../../../features/headerText/headerTextSlice.js";
import { reset as appSettingsReset } from "../../../features/appSettings/appSettingsSlice.js";
import { getBankFromCompany, getBankFromCompanyWiseSettingsId } from "../InvoicesSingle/services/invoiceSingle.js";
import { useBankAccountsWithCurrency } from "../../../hooks/useBankAccounts.js";
import CalendarIcon from '../../ui/CalendarIcon';

const InvoiceCreateManual = () => {
  const queryClient = useQueryClient();

  //  const [selectedValue, setSelectedValue] = useState("");
  const [showTooltip, setShowTooltip] = useState(false);
  const [showBankIndex, setShowBankIndex] = useState(-1);
  const [selUser, setSelUser] = useState("");
  const [isMobile, setIsMobile] = useState(() => typeof window !== 'undefined' && window.innerWidth <= 991);
  const [fromCalendarOpen, setFromCalendarOpen] = useState(false);
  const [toCalendarOpen, setToCalendarOpen] = useState(false);
  const [issueCalendarOpen, setIssueCalendarOpen] = useState(false);
  const [dueCalendarOpen, setDueCalendarOpen] = useState(false);

  useEffect(() => {
    const handleResize = () => setIsMobile(window.innerWidth <= 991);
    window.addEventListener('resize', handleResize);
    return () => window.removeEventListener('resize', handleResize);
  }, []);

  const formatDateStr = (dateObj) => {
    if (!dateObj || !(dateObj instanceof Date) || isNaN(dateObj.getTime())) return "DD/MM/YYYY";
    const day = String(dateObj.getDate()).padStart(2, '0');
    const month = String(dateObj.getMonth() + 1).padStart(2, '0');
    const year = dateObj.getFullYear();
    return `${day}/${month}/${year}`;
  };

  const [invType, setInvType] = useState("Regular");
  const [selUserCategory, setSelUserCategory] = useState("");
  const [showDateRangePicker, setShowDateRangePicker] = useState(false);
  const [defaultbank, setDefaultBank] = useState(false);
  const [defaultbankAccount, setDefaultBankAccount] = useState(false);
  const [expenseCategory, setExpenseCategory] = useState([]);
  const recipient = { id: "recipient-id" };
  const [issueDate, setIssueDate] = useState(moment.tz(global.config.getTimeZone()).toDate());
  const [dueDate, setDueDate] = useState(() => {
    const currentDate = new Date();
    const year = currentDate.getFullYear();
    const month = currentDate.getMonth();
    const lastDayOfMonth = new Date(year, month + 1, 0);
    return lastDayOfMonth;
  });
  const [title, setTitle] = useState("");
  const [subTotal, setSubTotal] = useState("00.00");
  const [taxTotal, setTaxTotal] = useState("00.00");
  const [total, setTotal] = useState("00.00");
  const [productDetails, setProductDetails] = useState([
    { description: "", projectId: "", cost: "", vat: "", price: "" },
  ]);
  const [invFiles, setInvFiles] = useState([]);
  const [otherComnt, setOtherComnt] = useState("");
  const [selUserEmail, setSelUserEmail] = useState("");
  const [isLoading, setIsLoading] = useState(false);
  const [modalIsOpen, setIsOpen] = useState(false);
  const [invNumber, setInvNumber] = useState("");
  const [invoiceBank, setInvoiceBank] = useState("");
  const [invoiceBankListName, setInvoiceBankListName] = useState("");
  const [invoiceBankCurrency, setInvoiceBankCurrency] = useState("");
  const [userName, setUserName] = useState("");
  const [userId, setUserId] = useState([]);
  const [projectId, setProjectId] = useState([]);
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const [invTypeDropdownOpen, setInvTypeDropdownOpen] = useState(false);
  const [companyDropdownOpen, setCompanyDropdownOpen] = useState(false);
  const [invTypeWiseDropdownOpen, setInvTypeWiseDropdownOpen] = useState(false);
  const [searchBankAccountTerm, setSearchBankAccountTerm] = useState('');
  const [bankAccountDropdownOpen, setBankAccountDropdownOpen] = useState(false);
  const [showWxCompanyModal, setShowWxCompanyModal] = useState(false);
  const [userWiseProfile, setUserWiseProfile] = useState(null);
  const [dateRangeIsValid, setDateRangeIsValid] = useState(false);
  const dateRangeRef = useRef(null);
  const hasLoadedInitialDataRef = useRef(false);
  const userHasChangedDateRef = useRef(false);
  const prevStartDateRef = useRef(null);
  const prevEndDateRef = useRef(null);
  const [issueDateIsValid, setIssueDateIsValid] = useState(false);
  const issueDateRef = useRef(null);
  const issuePickerRef = useRef(null);
  const duePickerRef = useRef(null);
  const [dueDateIsValid, setDueDateIsValid] = useState(false);
  const dueDateRef = useRef(null);
  const [titleIsValid, setTitleIsValid] = useState(false);
  const titleRef = useRef(null);
  const [bankIsValid, setBankIsValid] = useState(false);
  const bankRef = useRef(null);
  const [descriptionIsValid, setDescriptionIsValid] = useState(false);
  const [expenseCategoryIsValid, setExpenseCategoryIsValid] = useState(false);
  const descriptionRef = useRef(null);
  const [costIsValid, setCostIsValid] = useState(false);
  const costRef = useRef(null);
  const [taxIsValid, setTaxIsValid] = useState(false);
  const taxRef = useRef(null);
  const [wxCompany, setWxCompany] = useState(null);
  const [wiseSettingsId, setWiseSettingsId] = useState(null);
  const bankAccountDropdownRef = useRef(null);
  const invTypeDropdownRef = useRef(null);
  const companyeDropdownRef = useRef(null);
  const { appSettings } = useSelector((state) => state.appSettings);
  const [autoCurrency, setAutoCurrency] = useState([]);
  const [selectedProjects, setSelectedProjects] = useState(
    Array(productDetails.length).fill("Select Project")
  );
  const [dropdownOpenStates, setDropdownOpenStates] = useState(
    Array(productDetails.length).fill(false)
  );
  const dropdownRefs = useRef([]);

  const [newLineModalOpen, setNewLineModalOpen] = useState(false);
  const [newLineDesc, setNewLineDesc] = useState("");
  const [newLineCost, setNewLineCost] = useState("");
  const [newLineVat, setNewLineVat] = useState("");

  const handleAddLineItemSubmit = (e) => {
    e.preventDefault();
    const costNum = parseFloat(newLineCost) || 0;
    const vatNum = parseFloat(newLineVat) || 0;
    const amountNum = (costNum + costNum * (vatNum / 100)).toFixed(2);
    const newItem = {
      description: newLineDesc,
      projectId: "",
      cost: newLineCost,
      vat: newLineVat,
      amount: amountNum,
    };

    // Replace the initial empty row instead of leaving it as productDetails[0]
    const isEmptyFirst =
      productDetails.length === 1 &&
      !productDetails[0]?.description &&
      !productDetails[0]?.cost &&
      (!productDetails[0]?.amount || productDetails[0]?.amount === "00.00" || productDetails[0]?.amount === "0.00");

    const newProductDetails = isEmptyFirst
      ? [newItem]
      : [...productDetails, newItem];
    setProductDetails(newProductDetails);
    
    const { subTotal, taxTotal, total } = calculateSubTotalAndTax(newProductDetails);
    setSubTotal(subTotal);
    setTaxTotal(taxTotal);
    setTotal(total);

    if (isEmptyFirst) {
      setSelectedProjects([newLineDesc || "Select Project"]);
      setDropdownOpenStates([false]);
    } else {
      setSelectedProjects([...selectedProjects, newLineDesc || "Select Project"]);
      setDropdownOpenStates([...dropdownOpenStates, false]);
    }

    setNewLineDesc("");
    setNewLineCost("");
    setNewLineVat("");
    setNewLineModalOpen(false);
  };

  const toggleDropdown = (index) => {
    setDropdownOpenStates((prevStates) =>
      prevStates.map((state, i) => (i === index ? !state : state))
    );
  };

  const selectProjectOption = (project, index) => {
    setSelectedProjects((prevSelected) =>
      prevSelected.map((selected, i) => (i === index ? project.project_name : selected))
    );
    setDropdownOpenStates((prevStates) =>
      prevStates.map((state, i) => (i === index ? false : state))
    );

    const projecttestId = projectId.find((proj) => proj.project_name === project.project_name);
    const event = { target: { value: project.project_name, name: 'description' } };
    handleInputChange(event, index, "description");
    handleProjIdInputChange(event, index, projecttestId?._id);
  };

  // const expCategoryDropdownRef = useRef(null);
  let token = null;
  let createdBy = null;
  const { user } = useSelector((state) => state.auth);
  if (user) {
    if (user && user.token) {
      token = user.token;
      createdBy = user._id;
    }
  }

  const invoice = useSelector((state) => state.invoice);
  const [dateRange, setDateRange] = useState({
    startDate: new Date(),
    endDate: new Date(),
    key: "selection",
  });
  const handleSelect = useCallback((ranges) => {
    // Mark that user has manually changed the date - set this FIRST before any state updates
    userHasChangedDateRef.current = true;
    
    // rsuite DateRangePicker returns [startDate, endDate] or null
    if (ranges && Array.isArray(ranges) && ranges[0] && ranges[1]) {
      // Create new Date objects to ensure state updates
      const startDate = new Date(ranges[0]);
      const endDate = new Date(ranges[1]);
      
      // Update the refs immediately to prevent race conditions
      prevStartDateRef.current = startDate.toISOString();
      prevEndDateRef.current = endDate.toISOString();
      
      setDateRange({
        startDate: startDate,
        endDate: endDate,
        key: "selection",
      });
    } else if (ranges === null) {
      // Handle clearing the selection
      const now = new Date();
      prevStartDateRef.current = now.toISOString();
      prevEndDateRef.current = now.toISOString();
      
      setDateRange({
        startDate: now,
        endDate: now,
        key: "selection",
      });
    }
  }, []);

  // Suppress ResizeObserver loop errors (known browser issue, doesn't affect functionality)
  useEffect(() => {
    const originalError = window.onerror;
    const originalConsoleError = console.error;
    
    // Override window.onerror
    window.onerror = (message, source, lineno, colno, error) => {
      if (typeof message === 'string' && message.includes('ResizeObserver loop')) {
        return true; // Suppress the error
      }
      if (originalError) {
        return originalError(message, source, lineno, colno, error);
      }
      return false;
    };
    
    // Override console.error to catch ResizeObserver errors logged there
    console.error = (...args) => {
      const errorMessage = args.join(' ');
      if (errorMessage.includes('ResizeObserver loop')) {
        return; // Suppress the error
      }
      originalConsoleError.apply(console, args);
    };
    
    // Error event listener
    const handleError = (event) => {
      if (event.message && event.message.includes('ResizeObserver loop')) {
        event.stopImmediatePropagation();
        event.preventDefault();
        return true;
      }
      return false;
    };
    
    window.addEventListener('error', handleError, true);
    
    return () => {
      window.onerror = originalError;
      console.error = originalConsoleError;
      window.removeEventListener('error', handleError, true);
    };
  }, []);

  useEffect(() => {
    // Always set header text
    dispatch(setHeaderText("Invoices"));
  }, [dispatch]);

  useEffect(() => {
    // Early return if user has manually changed the date - this should prevent ALL resets
    if (userHasChangedDateRef.current) {
      return;
    }
    
    // Early return if we've already loaded the data
    if (hasLoadedInitialDataRef.current) {
      return;
    }
    
    async function fetchInvoiceUserData() {
      try {
        if (!invoice.selectedUser || !invoice.selectedUser[0] || !Array.isArray(invoice.selectedUser[0])) {
          return;
        }
        
        // Parse dates from ISO strings (stored in Redux as ISO strings)
        var startDateString = invoice.selectedUser[0][0];
        var endDateString = invoice.selectedUser[0][1];
        
        var startDate = new Date(startDateString);
        var endDate = new Date(endDateString);
        
        // Validate dates
        if (isNaN(startDate.getTime()) || isNaN(endDate.getTime())) {
          toast.error("Invalid date range data", {
            position: "bottom-right",
            autoClose: 2000,
            hideProgressBar: false,
            closeOnClick: true,
            pauseOnHover: true,
            draggable: true,
            progress: undefined,
            theme: "light",
          });
          return;
        }
        
        var startDateFormatted = startDate.toLocaleDateString("en-US", {
          day: "2-digit",
          month: "2-digit",
          year: "numeric",
        });
        var [startMonth, startDay, startYear] = startDateFormatted.split("/");
        var formattedStartDateString = `${startDay}/${startMonth}/${startYear}`;
        var endDateFormatted = endDate.toLocaleDateString("en-US", {
          day: "2-digit",
          month: "2-digit",
          year: "numeric",
        });
        var [month, day, year] = endDateFormatted.split("/");
        const formattedEndDateString = `${day}/${month}/${year}`;
        var formattedDateRange = `${formattedStartDateString} - ${formattedEndDateString}`;
        
        // Double-check: Only set dateRange if user hasn't manually changed it
        // This prevents race conditions where the useEffect might run after handleSelect
        if (!userHasChangedDateRef.current) {
          // Set dateRange as an object, not an array (to match state structure)
          setDateRange({
            startDate: startDate,
            endDate: endDate,
            key: "selection",
          });
          
          // Update refs to track what we set
          prevStartDateRef.current = startDateString;
          prevEndDateRef.current = endDateString;
        }
        
        hasLoadedInitialDataRef.current = true;
        
        setSelUser(invoice.selectedUser && invoice.selectedUser[1]);
        setInvType(invoice.selectedUser && invoice.selectedUser[4]);
        setSelUserCategory(invoice.selectedUser && invoice.selectedUser[3]);
        setSelUserEmail(invoice.selectedUser && invoice.selectedUser[2]);
      } catch (error) {
        global.config.slackMessage(error.toString());
        toast.error("Failed to load invoice data. Please try again.", {
          position: "bottom-right",
          autoClose: 3000,
          hideProgressBar: false,
          closeOnClick: true,
          pauseOnHover: true,
          draggable: true,
          progress: undefined,
          theme: "light",
        });
      }
    }
    
    // Only fetch data once when invoice.selectedUser is first available and hasn't been loaded yet
    const currentStartDate = invoice.selectedUser?.[0]?.[0];
    const currentEndDate = invoice.selectedUser?.[0]?.[1];
    
    // Only run if:
    // 1. We have data
    // 2. We haven't loaded it yet
    // 3. User hasn't manually changed the date
    // 4. The date values have actually changed (first time or new values)
    if (
      invoice.selectedUser && 
      !hasLoadedInitialDataRef.current && 
      !userHasChangedDateRef.current &&
      (prevStartDateRef.current !== currentStartDate || prevEndDateRef.current !== currentEndDate)
    ) {
      prevStartDateRef.current = currentStartDate;
      prevEndDateRef.current = currentEndDate;
      fetchInvoiceUserData();
    }
  }, [invoice.selectedUser?.[0]?.[0], invoice.selectedUser?.[0]?.[1]]); // Only depend on the actual date values, not the whole object
  const [wxCom, setWxCom] = useState(null);
  const [wxComProfileId, setWxComProfileId] = useState(null);

  useEffect(() => {
    async function fetchUser() {
      try {
        const response = await axios.get(`/api/user2/${invoice.selectedUser && invoice.selectedUser[1]}`, {
          headers: {
            Authorization: `Bearer ${token}`,
          },
        });
        let userName = '';
        setWxCom(response.data?.user_wx_comapny?.wx_company || null);
        setWxComProfileId(response.data?.user_wx_comapny?.profile_id || null);
        setAutoCurrency(response.data?.payment_currency || "USD");
        if (response.data.first_name && response.data?.first_name?.toLowerCase() !== 'null') {
          userName = response.data.first_name;
          if (response.data.middle_name && response.data?.middle_name?.toLowerCase() !== 'null') {
            userName += ' ' + response.data.middle_name;
          }
          userName += ' ' + response.data.last_name;
        } else {
          userName = response.data.company_name;
        }
        setUserId(response.data);
        setWxCompany(response.data?.user_wx_comapny?.wx_company || null);
        setUserName(userName);
        setDefaultBankAccount(response.data?.defaultBank || null);
        if (response?.data?.user_wx_comapny?.wx_company) {
          if (response?.data?.user_wx_comapny?.wx_company !== "Any") {
            setWiseProfile(response?.data?.user_wx_comapny.profile_id || null);
            setWiseSettingsId(response?.data?.user_wx_comapny.wiseSettingsId || null);
          }
        }
      } catch (error) {
        global.config.slackMessage(error.toString());
        if (error.response && error.response.status === 403) {
          // Redirect to 404 page
          navigate("../../../404");
        } else if (error.response && error.response.status === 401) {
          // Redirect to login page
          navigate("/user/login");
        } else if (error.response?.data?.status === "deleted") {
          localStorage.removeItem("user");
          dispatch(logout());
          dispatch(reset());
          dispatch(invoiceReset());
          dispatch(headerReset());
          dispatch(appSettingsReset());
          toast.error('This user is deleted!', {
            position: "bottom-right",
            autoClose: 1500,
            hideProgressBar: false,
            closeOnClick: true,
            pauseOnHover: true,
            draggable: true,
            progress: undefined,
            theme: "light",
          });
          navigate("/");
          return;
        } else {
          console.log(error);
          navigate("../../../404");
        }
      }
    }

    fetchUser();

    async function getUserWxCompany() {
      await axios
        .get(
          "/api/get-wx-comapies",
          {
            headers: {
              Authorization: `Bearer ${token}`,
            },
          }
        )
        .then((response) => {
          setUserWiseProfile(response.data.filter(
            (compny) =>
              compny.wx_company !== "Any"
          ));
        });
    }
    getUserWxCompany();

    async function fetchInvNumber() {
      try {
        const response = await axios.get("/api/invoice/invnumber", {
          headers: {
            Authorization: `Bearer ${token}`,
          },
        });
        setInvNumber(response.data);
      } catch (error) {
        console.log(error);
        global.config.slackMessage(error.toString());
        if (error.response?.data?.status === "deleted") {
          localStorage.removeItem("user");
          dispatch(logout());
          dispatch(reset());
          dispatch(invoiceReset());
          dispatch(headerReset());
          dispatch(appSettingsReset());
          toast.error('This user is deleted!', {
            position: "bottom-right",
            autoClose: 1500,
            hideProgressBar: false,
            closeOnClick: true,
            pauseOnHover: true,
            draggable: true,
            progress: undefined,
            theme: "light",
          });
          navigate("/");
          return;
        }
        alert("Something went wrong while fetching invoice number");
      }
    }

    fetchInvNumber();

    async function fetchProjectId() {
      try {

        const response = await axios.get("/api/all/project-details", {
          headers: {
            Authorization: `Bearer ${token}`,
          },
        });

        const filteredProjects = response.data.filter(project => project.is_archived !== true);

        setProjectId(filteredProjects);

      } catch (error) {

        console.log(error);
        global.config.slackMessage(error.toString());
        if (error.response?.data?.status === "deleted") {
          localStorage.removeItem("user");
          dispatch(logout());
          dispatch(reset());
          dispatch(invoiceReset());
          dispatch(headerReset());
          dispatch(appSettingsReset());
          toast.error('This user is deleted!', {
            position: "bottom-right",
            autoClose: 1500,
            hideProgressBar: false,
            closeOnClick: true,
            pauseOnHover: true,
            draggable: true,
            progress: undefined,
            theme: "light",
          });
          navigate("/");
          return;
        }
        alert("Something went wrong while fetching project");

      }
    }
    fetchProjectId();

    async function fetchExpenseCategory() {
      try {
        const response = await axios.get("/api/expense-categories", {
          headers: {
            Authorization: `Bearer ${token}`,
          },
        });


        setExpenseCategory(response.data.data);

      } catch (error) {
        global.config.slackMessage(error.toString());
        console.log(error);
        alert("Something went wrong while fetching invoice number");
      }
    }

    fetchExpenseCategory();

    const handleKeyDown = (event) => {
      if (event.key === "Escape") {
        document.activeElement.blur();
      }
    };
    document.addEventListener("keydown", handleKeyDown);
    return () => {
      document.removeEventListener("keydown", handleKeyDown);
    };
  }, [invoice.selectedUser]);

  // Bank fetching is now handled by React Query hook
  // No need for manual useEffect

  function closeModal() {
    setIsOpen(false);
    navigate("/user/invoices", { state: { fromInvoiceAction: true } });
  }

  function addBank() {
    if (user.userType === userTypeConsts.SUPER_ADMIN || user.userType === userTypeConsts.ADMIN) {
      const encryptedId = AES.encrypt(selUser, 'encryptionKey').toString();
      const encodedId = encodeURIComponent(encryptedId).replace(/\//g, '%2F');
      localStorage.setItem('activeTab', '1');
      navigate(`../profile/${encodedId}`);
    } else {
      localStorage.setItem('activeTab', '1');
      navigate(`../profile/settings`, '_blank');
    }
  }

  const addCompany = () => {
    if (user.userType === userTypeConsts.SUPER_ADMIN || user.userType === userTypeConsts.ADMIN) {
      localStorage.setItem('activeTab', '2');
      navigate("/user/account/settings");
    } else {
      navigate("/user/invoices", { state: { fromInvoiceAction: true } });
    }
  };

  function handleBankLinkClick(index) {
    setShowBankIndex((prevIndex) => (prevIndex === index ? -1 : index));
  }

  function handleRadioChange() {
    setDefaultBank(true);
  }

  const handleIssueDateChange = (date) => {

    if (!dueDate || new Date(date) <= new Date(dueDate)) {
      setIssueDate(moment.tz(date, global.config.getTimeZone()).toDate());
    } else {

      toast.error("Issue date must be before due date", {
        position: "bottom-right",
        autoClose: 2000,
        hideProgressBar: false,
        closeOnClick: true,
        pauseOnHover: true,
        draggable: true,
        progress: undefined,
      });
    }
  };

  const ranges = [
    {
      label: "today",
      value: new Date(), // Use a single date instead of an array
    },
    {
      label: "yesterday",
      value: subDays(new Date(), 1),
    },
  ];

  const handleDueDateChange = (date) => {
    if (!issueDate || new Date(date) >= new Date(issueDate)) {
      setDueDate(date);
    } else {
      toast.error("Due date must be after issue date", {
        position: "bottom-right",
        autoClose: 2000,
        hideProgressBar: false,
        closeOnClick: true,
        pauseOnHover: true,
        draggable: true,
        progress: undefined,
      });
    }
  };

  const handleAddRow = (e) => {
    e.preventDefault();
    const newProductDetails = [
      ...productDetails,
      { description: "", projectId: "", cost: "", vat: "", price: "" },
    ];
    setProductDetails(newProductDetails);

    setSelectedProjects([...selectedProjects, "Select Project"]);
    setDropdownOpenStates([...dropdownOpenStates, false]);
  };

  const handleRemoveRow = (indexToRemove, e) => {
    const newProductDetails = [...productDetails];
    newProductDetails.splice(indexToRemove, 1);
    setProductDetails(newProductDetails);
    const { subTotal, taxTotal, total } = calculateSubTotalAndTax(newProductDetails);
    setSubTotal(subTotal);
    setTaxTotal(taxTotal);
    setTotal(total);

    setSelectedProjects(selectedProjects.filter((_, i) => i !== indexToRemove));
    setDropdownOpenStates(dropdownOpenStates.filter((_, i) => i !== indexToRemove));
  };

  const calculateSubTotalAndTax = (details) => {
    let subTotal = 0;
    let taxTotal = 0;
    let total = 0;
    details.forEach((detail) => {

      var cost = parseFloat(detail.cost) || 0;
      var tax = parseFloat(detail.vat) || 0;
      const amount = cost + cost * (tax / 100);
      subTotal += cost;
      taxTotal += amount - cost;
      total += amount;
    });
    return { subTotal: subTotal.toFixed(2), taxTotal: taxTotal.toFixed(2), total: total.toFixed(2) };
  };

  const handleInputChange = (event, index, field) => {
    const { name, value } = event.target;
    const newProductDetails = [...productDetails];
    newProductDetails[index][name] = value;
    if (field === "cost" || field === "vat") {
      const cost = parseFloat(newProductDetails[index].cost) || 0;
      const vat = parseFloat(newProductDetails[index].vat) || 0;
      if (!isNaN(cost) && !isNaN(vat)) {
        newProductDetails[index].amount = (cost + cost * (vat / 100)).toFixed(
          2
        );
      }
    }
    setProductDetails(newProductDetails);
    const tax = calculateTax();
    setTaxTotal(tax);
    const subtotal = calculateSubtotal();
    setSubTotal(subtotal);
    const total = calculateTotal();
    setTotal(total);

  };

  const handleProjIdInputChange = (event, index, field) => {
    const newProductDetails = [...productDetails];
    newProductDetails[index]["projectId"] = field;
    setProductDetails(newProductDetails);
  };

  const calculateSubtotal = () => {
    let subtotal = 0;
    productDetails.forEach((detail) => {
      const cost = parseFloat(detail.cost) || 0;
      subtotal += cost;
    });
    return subtotal.toFixed(2);
  };

  const calculateTax = () => {

    let tax = 0;
    productDetails.forEach((detail) => {
      const cost = parseFloat(detail.cost) || 0;
      const vat = parseFloat(detail.vat) || 0;
      const amount = cost + cost * (vat / 100);
      tax += amount - cost;
    });
    return tax.toFixed(2);

  };

  const calculateTotal = () => {
    const subtotal = parseFloat(calculateSubtotal());
    const tax = parseFloat(calculateTax());
    return (subtotal + tax).toFixed(2);
  };

  const handleClosePicker = () => {
    setShowDateRangePicker(false);
  };

  const handleInvTypeToggleDropdown = () => {
    setInvTypeDropdownOpen(!invTypeDropdownOpen);
  };

  const handleInvTypeWiseToggleDropdown = () => {
    setInvTypeWiseDropdownOpen(!invTypeWiseDropdownOpen);
  };
  const handleCompanyToggleDropdown = () => {
    setCompanyDropdownOpen(!companyDropdownOpen);
  };

  const handleInvTypeSelectOption = (value) => {
    setInvType(value);
    setInvTypeDropdownOpen(false);
  };

  const handleToggleDropdown = () => {
    setSearchBankAccountTerm('');
    setBankAccountDropdownOpen(!bankAccountDropdownOpen);
  };

  const handleSelectOption = (invoiceBank) => {
    const bankSelect = invoiceBank.split("_");
    setInvoiceBankCurrency(bankSelect[1]);
    setInvoiceBank(bankSelect[0]);
    setInvoiceBankListName(invoiceBank);
    setBankAccountDropdownOpen(false);
  };

  const handleSearchInputChange = (e) => {
    setSearchBankAccountTerm(e.target.value);
  };

  // autoCurrencyFilteredBankDetails is now provided by the React Query hook
  // filteredBankDetails will be declared after the React Query hook

  const openPaymentModal = (e) => {

    setIssueDateIsValid(false);
    setTitleIsValid(false);
    setBankIsValid(false);
    setDescriptionIsValid(false);
    setCostIsValid(false);
    setTaxIsValid(false);
    if (
      invNumber === "" ||
      dateRange === null ||
      issueDate === null ||
      dueDate === null ||
      title === "" ||
      selUserEmail === "" ||
      productDetails[0].description.length === 0 ||
      productDetails[0].cost.length === 0 ||
      productDetails[0].amount.length === 0 ||
      productDetails[0]?.vat?.length === 0 ||
      (invType === "Reimbursement" && productDetails[0]?.expenseCategory?.length === 0) ||
      selUser === "" ||
      invoiceBankCurrency === "" ||
      invType === "" ||
      subTotal === "00.00" ||
      subTotal <= 0 ||
      total === "00.00" ||
      total <= 0
    ) {
      if (dateRange === null) {
        setDateRangeIsValid(true);
        toast.error("Date range cannot be empty!", {
          position: "bottom-right",
          autoClose: 2000,
          hideProgressBar: false,
          closeOnClick: true,
          pauseOnHover: true,
          draggable: true,
          progress: undefined,
        });
        dateRangeRef.current?.focus();
      } else if (issueDate === null) {
        setIssueDateIsValid(true);
        toast.error("Issue date cannot be empty!", {
          position: "bottom-right",
          autoClose: 2000,
          hideProgressBar: false,
          closeOnClick: true,
          pauseOnHover: true,
          draggable: true,
          progress: undefined,
        });
        issueDateRef.current?.focus();
      } else if (dueDate === null) {
        setDueDateIsValid(true);
        toast.error("Due date cannot be empty!", {
          position: "bottom-right",
          autoClose: 2000,
          hideProgressBar: false,
          closeOnClick: true,
          pauseOnHover: true,
          draggable: true,
          progress: undefined,
        });
        dueDateRef.current?.focus();
      } else if (title === "") {
        setTitleIsValid(true);
        titleRef.current?.focus();
      } else if (productDetails[0].description.length === 0) {
        setDescriptionIsValid(true);
        descriptionRef.current?.focus();
      } else if (productDetails[0].cost.length === 0) {
        setCostIsValid(true);
        costRef.current?.focus();
      } else if (productDetails[0]?.vat?.length === 0) {
        setTaxIsValid(true);
        taxRef.current?.focus();
      } else if (subTotal === "00.00" || subTotal <= 0) {
        toast.error("Subtotal must be greater than 0!", {
          position: "bottom-right",
          autoClose: 2000,
          hideProgressBar: false,
          closeOnClick: true,
          pauseOnHover: true,
          draggable: true,
          progress: undefined,
        });
        return;
      } else if (total === "00.00" || total <= 0) {
        toast.error("Total must be greater than 0!", {
          position: "bottom-right",
          autoClose: 2000,
          hideProgressBar: false,
          closeOnClick: true,
          pauseOnHover: true,
          draggable: true,
          progress: undefined,
        });
        return;
      }

      if (invType === "Reimbursement" && productDetails[0]?.expenseCategory?.length === 0) {
        setExpenseCategoryIsValid(true);
      }

      toast.error("Please fill all required fields!", {
        position: "bottom-right",
        autoClose: 2000,
        hideProgressBar: false,
        closeOnClick: true,
        pauseOnHover: true,
        draggable: true,
        progress: undefined,
      });
      return;
    }

    if (
      productDetails.some(
        (product) =>
          product.description.length === 0 ||
          product.cost.length === 0 ||
          product.amount.length === 0 ||
          product?.vat?.length === 0
      )
    ) {
      // Handle empty product details
      if (productDetails[0].description.length === 0) {
        setDescriptionIsValid(true);
        descriptionRef.current?.focus();
      } else if (productDetails[0].cost.length === 0) {
        setCostIsValid(true);
        costRef.current?.focus();
      }

      toast.error("Please fill all required fields in details!", {
        position: "bottom-right",
        autoClose: 2000,
        hideProgressBar: false,
        closeOnClick: true,
        pauseOnHover: true,
        draggable: true,
        progress: undefined,
      });
      return;
    }
    handleSubmit(e);
  }


  function closeWXCompanyModal() {
    if (wxCompany && wxCompany !== "Any") {
      setWxCompany("Any");
    }
    setShowWxCompanyModal(false);
  }

  const handleSubmit = async (event) => {
    event.preventDefault();
    setIssueDateIsValid(false);
    setTitleIsValid(false);
    setBankIsValid(false);
    setDescriptionIsValid(false);
    setCostIsValid(false);
    setTaxIsValid(false);
    if (
      invNumber === "" ||
      dateRange === null ||
      issueDate === null ||
      dueDate === null ||
      title === "" ||
      selUserEmail === "" ||
      productDetails[0].description.length === 0 ||
      productDetails[0].cost.length === 0 ||
      productDetails[0].amount.length === 0 ||
      selUser === "" ||
      invoiceBankCurrency === "" ||
      invType === "" ||
      invoiceBank === "" ||
      subTotal === "00.00" ||
      subTotal <= 0 ||
      total === "00.00" ||
      total <= 0
    ) {
      if (dateRange === null) {
        setDateRangeIsValid(true);
        toast.error("Date range cannot be empty!", {
          position: "bottom-right",
          autoClose: 2000,
          hideProgressBar: false,
          closeOnClick: true,
          pauseOnHover: true,
          draggable: true,
          progress: undefined,
        });
        dateRangeRef.current?.focus();
        return;
      } else if (issueDate === null) {
        setIssueDateIsValid(true);
        toast.error("Issue date cannot be empty!", {
          position: "bottom-right",
          autoClose: 2000,
          hideProgressBar: false,
          closeOnClick: true,
          pauseOnHover: true,
          draggable: true,
          progress: undefined,
        });
        issueDateRef.current?.focus();
        return;
      } else if (dueDate === null) {
        setDueDateIsValid(true);
        toast.error("Due date cannot be empty!", {
          position: "bottom-right",
          autoClose: 2000,
          hideProgressBar: false,
          closeOnClick: true,
          pauseOnHover: true,
          draggable: true,
          progress: undefined,
        });
        dueDateRef.current?.focus();
        return;
      } else if (title === "") {
        setTitleIsValid(true);
        titleRef.current?.focus();
        return;
      } else if (invoiceBank === "") {
        setBankIsValid(true);
        bankRef.current?.focus();
        return;
      } else if (productDetails[0].description.length === 0) {
        setDescriptionIsValid(true);
        descriptionRef.current?.focus();
        return;
      } else if (productDetails[0].cost.length === 0) {
        setCostIsValid(true);
        costRef.current?.focus();
        return;
      } else if (subTotal === "00.00" || subTotal <= 0) {
        toast.error("Subtotal must be greater than 0!", {
          position: "bottom-right",
          autoClose: 2000,
          hideProgressBar: false,
          closeOnClick: true,
          pauseOnHover: true,
          draggable: true,
          progress: undefined,
        });
        return;
      } else if (total === "00.00" || total <= 0) {
        toast.error("Total must be greater than 0!", {
          position: "bottom-right",
          autoClose: 2000,
          hideProgressBar: false,
          closeOnClick: true,
          pauseOnHover: true,
          draggable: true,
          progress: undefined,
        });
        return;
      }

      if (invType === "Reimbursement") {

        if (productDetails[0].expenseCategory.length === 0) {
          setExpenseCategoryIsValid(true);
          return;
        }

      }

      toast.error("Please fill all required fields!", {
        position: "bottom-right",
        autoClose: 2000,
        hideProgressBar: false,
        closeOnClick: true,
        pauseOnHover: true,
        draggable: true,
        progress: undefined,
      });
      return;
    }

    setIsLoading(true);
    const descriptions = productDetails.map((product) => product.description);
    const projectIds = productDetails.map((product) => product.projectId);
    var expenseCategory = [];
    if (invType === "Reimbursement") {
      expenseCategory = productDetails.map((product) => product.expenseCategory);
    }
    const prices = productDetails.map((product) => product.amount);
    const costs = productDetails.map((product) => product.cost);
    const taxes = productDetails.map((product) => product.vat);
    const invoiceData = {
      inv_number: invNumber,
      inv_start_date: moment.tz(dateRange.startDate, global.config.getTimeZone()).utc().toDate(),
      inv_end_date: moment.tz(dateRange.endDate, global.config.getTimeZone()).utc().toDate(),
      inv_issue_date: moment.tz(issueDate, global.config.getTimeZone()).utc().toDate(),  //moment.utc(issueDate).tz(global.config.getTimeZone()).format('YYYY-MM-DD'),
      inv_due_date: moment.tz(dueDate, global.config.getTimeZone()).utc().toDate(), //moment.utc(dueDate).tz(global.config.getTimeZone()).format('YYYY-MM-DD'),
      inv_title: title,
      inv_company_name: wxCompany,
      inv_email: selUserEmail,
      inv_description: JSON.stringify(descriptions),
      inv_projectId: JSON.stringify(projectIds),
      inv_category: JSON.stringify(expenseCategory),
      inv_price: JSON.stringify(prices),
      inv_cost: JSON.stringify(costs),
      inv_tax: JSON.stringify(taxes),
      inv_sub_total: subTotal,
      inv_for: selUser,
      inv_total_tax: taxTotal,
      inv_total_amount: total,
      inv_currency: invoiceBankCurrency,
      inv_type: invType,
      inv_bank: invoiceBank,
      inv_other_comments: otherComnt,
      inv_bank_profile: wiseProfile,
      is_automatic_inv: false,
      inv_created_by: createdBy,
    };

    // Create a new FormData object
    const formData = new FormData();
    for (let i = 0; i < invFiles.length; i++) {
      formData.append("inv_file", invFiles[i]);
    }
    // Append the other request data to the form data
    for (let key in invoiceData) {
      formData.append(key, invoiceData[key]);
    }

    if (invoiceBank) {
      try {
        const response = await axios.post("/api/invoice", formData,
          {
            headers: {
              Authorization: `Bearer ${token}`,
            },
          });
        const data = response.data;

        if (data.status === "Error") {

          toast.error("Something went wrong in creating invoice!!", {
            position: "bottom-right",
            autoClose: 2000,
            hideProgressBar: false,
            closeOnClick: true,
            pauseOnHover: true,
            draggable: true,
            progress: undefined,
          });
        } else {
          // Invalidate invoices query cache to trigger refetch
          queryClient.invalidateQueries("invoices");
          
          toast.success("Invoice created successfully", {
            position: "bottom-right",
            autoClose: 2000,
            hideProgressBar: false,
            closeOnClick: true,
            pauseOnHover: true,
            draggable: true,
            progress: undefined,
          });
          global.config.activityLog(
            window.location.href,
            "Invoice",
            `Invoice "${invNumber}" (manual) created Successfully`
          );
          navigate("/user/invoices", { state: { fromInvoiceAction: true } });
        }
      } catch (error) {
        global.config.slackMessage(error.toString());
        if (error.response.data.status === "mailfailed") {
          // Invalidate invoices query cache to trigger refetch
          queryClient.invalidateQueries("invoices");
          
          toast.error("Invoice created successsfully! but something went wrong in sending mail!!", {
            position: "bottom-right",
            autoClose: 3500,
            hideProgressBar: false,
            closeOnClick: true,
            pauseOnHover: true,
            draggable: true,
            progress: undefined,
          });

          navigate("/user/invoices", { state: { fromInvoiceAction: true } });
        } else if (error.response?.data?.status === "deleted") {
          localStorage.removeItem("user");
          dispatch(logout());
          dispatch(reset());
          dispatch(invoiceReset());
          dispatch(headerReset());
          dispatch(appSettingsReset());
          toast.error('This user is deleted!', {
            position: "bottom-right",
            autoClose: 1500,
            hideProgressBar: false,
            closeOnClick: true,
            pauseOnHover: true,
            draggable: true,
            progress: undefined,
            theme: "light",
          });
          navigate("/");
          return;
        } else {
          console.log(error);
          toast.error("Something went wrong while creating invoice", {
            position: "bottom-right",
            autoClose: 2000,
            hideProgressBar: false,
            closeOnClick: true,
            pauseOnHover: true,
            draggable: true,
            progress: undefined,
          });
          global.config.activityLog(
            window.location.href,
            "Invoice",
            `Invoice "${invNumber}" creation having some error.`
          );
        }
      }
    } else {
      setShowWxCompanyModal(false);
      toast.error('Please select a bank account!', {
        position: "bottom-right",
        autoClose: 1500,
        hideProgressBar: false,
        closeOnClick: true,
        pauseOnHover: true,
        draggable: true,
        progress: undefined,
        theme: "light",
      });
    }
    setIsLoading(false);
  };

  const allowedExtensions = ["pdf", "doc", "docx", "msword", "xls", "xlsx", "csv", "jpeg", "jpg", "png", "gif"];
  const handleInvDocChange = (event) => {
    const selectedFiles = event.target.files;

    if (selectedFiles.length > 0) {
      if (selectedFiles.length + invFiles.length > 10) {
        // Display toast error message when the total number of files exceeds 10
        toast.error('Maximum of 10 files can be uploaded!', {
          position: 'bottom-right',
          autoClose: 3500,
          hideProgressBar: false,
          closeOnClick: true,
          pauseOnHover: true,
          draggable: true,
          progress: undefined,
        });
        return;
      }
      const newFiles = Array.from(selectedFiles);

      // Validate file extensions and update state
      const validFiles = newFiles.filter((file) => {
        const fileExtension = file.name.split('.').pop()?.toLowerCase();
        if (allowedExtensions.includes(fileExtension)) {
          return true;
        } else {
          toast.error(`Invalid file format for ${file.name}. Allowed formats are pdf, doc, docx, msword, xls, xlsx, csv.!!`, {
            position: 'bottom-right',
            autoClose: 3500,
            hideProgressBar: false,
            closeOnClick: true,
            pauseOnHover: true,
            draggable: true,
            progress: undefined,
          });
          return false;
        }
      });

      // Update the state with the valid files
      setInvFiles((prevFiles) => [...prevFiles, ...validFiles]);

      // Clear the file input for multiple selections
      fileInputRef.current.value = '';
    }
  };

  const removeFile = (index) => {
    // Remove the file at the specified index
    setInvFiles((prevFiles) => {
      const updatedFiles = [...prevFiles];
      updatedFiles.splice(index, 1);
      return updatedFiles;
    });
  };

  const handleDropdownChange = (event) => {
    selectBankAccount(event.target.value);
  };

  const selectBankAccount = (invoiceBank) => {
    const bankSelect = invoiceBank.split("_");
    setInvoiceBankCurrency(bankSelect[1]);
    setInvoiceBank(bankSelect[0]);
    setInvoiceBankListName(invoiceBank);
  };

  const handleClickOutsideDropdown = (event) => {
    const isClickInsideInvTypeDropdown = invTypeDropdownRef.current && invTypeDropdownRef.current.contains(event.target);
    const isClickInsideBankAccountDropdown = bankAccountDropdownRef.current && bankAccountDropdownRef.current.contains(event.target);
    const isClickInsideCompanyDropdown = companyeDropdownRef.current && companyeDropdownRef.current.contains(event.target);
    if (!isClickInsideInvTypeDropdown) {
      setInvTypeDropdownOpen(false);
    }
    if (!isClickInsideBankAccountDropdown) {
      setBankAccountDropdownOpen(false);
    }
    if (!isClickInsideCompanyDropdown) {
      setCompanyDropdownOpen(false);
    }
  };

  useEffect(() => {
    document.addEventListener('click', handleClickOutsideDropdown);
    return () => {
      document.removeEventListener('click', handleClickOutsideDropdown);
    };
  }, []);

  const handleTooltipToggle = () => {
    setShowTooltip(!showTooltip);
  };
  const fileInputRef = useRef(null);

  const handleClick = () => {
    fileInputRef.current.click();
  };

  const numberInputOnWheelPreventChange = (e) => {
    // Prevent the input value change
    e.target.blur()
    // Prevent the page/container scrolling
    e.stopPropagation()

    setTimeout(() => {
      e.target.focus()
    }, 0)
  }

  const [wiseModalIsOpen, setWiseModalIsOpen] = useState(false);
  const [isWiseProfileLoading, setIsWiseProfileLoading] = useState(true);
  const [wiseCompany, setWiseCompany] = useState([]);
  const [wiseProfile, setWiseProfile] = useState(null);
  const [wiseProfileLabel, setWiseProfileLabel] = useState(null);

  // React Query hook for bank accounts with polling
  const {
    data: bankDetails = [],
    filteredData: autoCurrencyFilteredBankDetails = [],
    isLoading: isBankLoading,
    isError: isBankError,
    error: bankError,
    refetch: refetchBanks
  } = useBankAccountsWithCurrency({
    wiseProfileId: wiseProfile,
    userEmail: selUserEmail,
    token: token,
    wxCompany: wxCompany,
    wiseSettingsId: wiseSettingsId, // set when company is selected
    preferredCurrency: autoCurrency,
    enabled: !!selUserEmail && !!token && (!!wiseProfile || !!wiseSettingsId)
  });

  // Set default bank account when bankDetails or defaultbankAccount changes
  useEffect(() => {
    const targetObject = ((bankDetails && defaultbankAccount) && bankDetails.find(item => item.id === parseInt(defaultbankAccount)));
    setInvoiceBankListName((defaultbankAccount && bankDetails && targetObject) && `${defaultbankAccount}_${targetObject && targetObject.currency}`);
    setInvoiceBankCurrency((defaultbankAccount && bankDetails && targetObject) && targetObject.currency);
    setInvoiceBank((defaultbankAccount && bankDetails && targetObject) && defaultbankAccount);
  }, [bankDetails, defaultbankAccount]);

  // Filter bank details by search term
  const filteredBankDetails = autoCurrencyFilteredBankDetails?.filter((bank) =>
    `${bank.details.accountNumber || ''} ${bank.details.IBAN || ''} ${bank.currency || ''} ${bank.country || ''}`
      ?.toLowerCase()
      .includes(searchBankAccountTerm?.toLowerCase())
  );

  // Find selected bank
  const selectedBank = autoCurrencyFilteredBankDetails.find((bank) => `${bank.id}_${bank.currency}` === invoiceBankListName);

  useEffect(() => {
    async function getUserWiseProfile() {
      setIsWiseProfileLoading(true);
      try {
        const response = await axios.post(
          "/api/wise/user-wise-profile",
          {
            userId: `${invoice.selectedUser && invoice.selectedUser[1]}`,
          },
          {
            headers: {
              Authorization: `Bearer ${token}`,
            },
          }
        );

        if (response.data.status === false) {
          setWiseModalIsOpen(true);
        } else {
          setWiseCompany(response.data);
        }
      } catch (error) {
        console.error("Error fetching user-wise profile:", error);
        setWiseModalIsOpen(true);
      } finally {
        setIsWiseProfileLoading(false);
      }
    }
    getUserWiseProfile();
  }, []);

  // Check for URL parameter to automatically open bank account
  useEffect(() => {
    const urlParams = new URLSearchParams(window.location.search);
    if (urlParams.get('openBankAccount') === 'true') {
      // Set the active tab to bank accounts (tab 1)
      localStorage.setItem('activeTab', '1');
      // The profile page component will handle the tab switching based on localStorage
    }
  }, []);

  const closeWiseModal = () => {
    setWiseModalIsOpen(false);
    navigate("/user/invoices", { state: { fromInvoiceAction: true } });
  };

  const goToWisePage = () => {
    setWiseModalIsOpen(false);
    if (user.userType === userTypeConsts.SUPER_ADMIN || user.userType === userTypeConsts.ADMIN) {
      localStorage.setItem('activeTab', '1');
      navigate("/user/account/settings");
    } else {
      navigate("/user/invoices", { state: { fromInvoiceAction: true } });
    }
  };

  const handleCompanySelect = async (item) => {
    setWiseProfile(item.profile_id);
    setWiseSettingsId(item.wiseSettingsId || null);
    setWxCompany(item.wx_company);
    setCompanyDropdownOpen(false);
    // Clear bank selection so user picks from the new company's accounts
    setInvoiceBank("");
    setInvoiceBankListName("");
    setInvoiceBankCurrency("");
  }
  const encryptedId = AES.encrypt(invoice.selectedUser[1], 'encryptionKey').toString();
  const encodedId = encodeURIComponent(encryptedId).replace(/\//g, '%2F');

  // selectedBank will be declared after the React Query hook

  const getBankDisplayText = (bank) => {
    if (!bank) return 'Select Bank';

    const { details = {}, currency } = bank;
    const { accountNumber, IBAN, clabe, bankCode } = details;

    if (clabe) return `${clabe} (${currency || invoiceBankCurrency})`;
    if (accountNumber && IBAN) return `${accountNumber} ${IBAN} (${currency || invoiceBankCurrency})`;
    if (accountNumber) return `${accountNumber} (${currency || invoiceBankCurrency})`;
    if (IBAN) return `${IBAN} (${currency || invoiceBankCurrency})`;
    if (bankCode) return `${bankCode} (${currency || invoiceBankCurrency})`;

    return 'Select Bank';
  };

  return (
    <div className="s1-containauto">
      <div className="back-to invoice-create-back-to">
        <Link to="/user/invoices">Back to all invoices</Link>
      </div>
      <form>
        <div className="mobile-back-all-invoices-header">
          <Link to="/user/invoices" className="mobile-back-all-invoices-link">
            <svg width="6" height="10" viewBox="0 0 6 10" fill="none" xmlns="http://www.w3.org/2000/svg">
              <path d="M5 9L1 5L5 1" stroke="#64748B" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round"/>
            </svg>
            Back to All Invoices
          </Link>
        </div>
        <div className="fs-head-autoinvo">
          <div className="bill-num-si">
            {!invNumber ? (
              <div
                style={{
                  width: "150px",
                  height: "32px",
                  backgroundColor: "#e5e7eb",
                  borderRadius: "4px",
                  animation: "pulse 1.5s ease-in-out infinite",
                }}
              />
            ) : (
              <Link className="invoice-num-01">{invNumber}</Link>
            )}
          </div>
          <div className="btn-aary">
            <Link to="/user/invoices" className="cancelbtn-link">
              <img src={cancelImage} alt="cancel" /> Cancel
            </Link>
          </div>
        </div>
        <div className="m-edit-main">
          <div className="edit-sheet-manual01">
            <div className="headder-outter-res-mainu">
              <div className="sheet-manual-header">
                <div className="type-dropdown-em">
                  <div className="dp-main-head-em">Type</div>
                  <div className="custom-dropdown">

                    <div ref={invTypeDropdownRef} className={`custom-dropdown-user-new-outer custom-dropdown-select ${invTypeDropdownOpen ? 'open' : ''}`}>
                      <div className="selected-option custom-dropdown-user-new" onClick={handleInvTypeToggleDropdown}>
                        <span>{invType ? invType : 'Select Type'}</span>
                        <svg width="18" height="9" viewBox="0 0 18 9" fill="none" xmlns="http://www.w3.org/2000/svg" className="type-dropdown-arrow-icon dropdown-chevron-icon">
                          <path d="M1.5 1.5L9 7.5L16.5 1.5" stroke="#405BFF" strokeWidth="1.2" strokeLinecap="round" strokeLinejoin="round"/>
                        </svg>
                      </div>
                      <AnimatePresence>
                        {invTypeDropdownOpen && (
                          <motion.div
                            className="custom-dropdown-new"
                            initial={{ opacity: 0, y: -6, scale: 0.97 }}
                            animate={{ opacity: 1, y: 0, scale: 1 }}
                            exit={{ opacity: 0, y: -6, scale: 0.97 }}
                            transition={{ duration: 0.15, ease: "easeOut" }}
                          >
                            <ul className="type-list">
                              <li className={invType === 'Regular' ? 'selected-item' : ''} onClick={() => handleInvTypeSelectOption('Regular')}>Regular Invoice</li>
                              <li className={invType === 'Reimbursement' ? 'selected-item' : ''} onClick={() => handleInvTypeSelectOption('Reimbursement')}>Reimbursement Invoice</li>
                            </ul>
                          </motion.div>
                        )}
                      </AnimatePresence>
                    </div>
                    <span className="custom-arrow"></span>
                  </div>
                  <div className="tactic00i">
                    <img
                      src={whatis}
                      alt="tool-tip"
                      onMouseEnter={handleTooltipToggle}
                      onMouseLeave={handleTooltipToggle}
                    />
                  </div>
                </div>
                <div className="invo-date-rangeme">
                  <div className="invo-date-range-tile">Date Range</div>
                  {isMobile ? (
                    <div className="mobile-date-range-container" ref={dateRangeRef}>
                      <div className="mobile-date-field" onClick={() => setFromCalendarOpen(true)}>
                        <span className="mobile-date-label">From</span>
                        <span className="mobile-date-val">{formatDateStr(dateRange.startDate)}</span>
                        <svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="#6366F1" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
                          <rect x="3" y="4" width="18" height="18" rx="2" ry="2"></rect>
                          <line x1="16" y1="2" x2="16" y2="6"></line>
                          <line x1="8" y1="2" x2="8" y2="6"></line>
                          <line x1="3" y1="10" x2="21" y2="10"></line>
                        </svg>
                      </div>
                      <div className="mobile-date-field" onClick={() => setToCalendarOpen(true)}>
                        <span className="mobile-date-label">To</span>
                        <span className="mobile-date-val">{formatDateStr(dateRange.endDate)}</span>
                        <svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="#6366F1" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
                          <rect x="3" y="4" width="18" height="18" rx="2" ry="2"></rect>
                          <line x1="16" y1="2" x2="16" y2="6"></line>
                          <line x1="8" y1="2" x2="8" y2="6"></line>
                          <line x1="3" y1="10" x2="21" y2="10"></line>
                        </svg>
                      </div>
                      <div style={{ opacity: 0, height: 0, overflow: 'hidden', position: 'absolute', pointerEvents: 'none' }}>
                        <DatePicker
                          open={fromCalendarOpen}
                          onClose={() => setFromCalendarOpen(false)}
                          oneTap
                          format="dd/MM/yyyy"
                          value={dateRange.startDate}
                          onChange={(val) => {
                            if (val) {
                              handleSelect([new Date(val), dateRange.endDate]);
                            }
                            setFromCalendarOpen(false);
                          }}
                          placement="auto"
                          isoWeek={appSettings?.weekStartDay === 'Monday'}
                        />
                        <DatePicker
                          open={toCalendarOpen}
                          onClose={() => setToCalendarOpen(false)}
                          oneTap
                          format="dd/MM/yyyy"
                          value={dateRange.endDate}
                          onChange={(val) => {
                            if (val) {
                              handleSelect([dateRange.startDate, new Date(val)]);
                            }
                            setToCalendarOpen(false);
                          }}
                          placement="auto"
                          isoWeek={appSettings?.weekStartDay === 'Monday'}
                        />
                      </div>
                    </div>
                  ) : (
                    <div className="invo-date-range-cal" ref={dateRangeRef}>
                      <div className="date-picker-outer date-picker-outer-all">
                        <div className="custoom-icon-calender custoom-icon-calender-all">
                          <DateRangePicker
                            showOneCalendar
                            format="dd/MM/yyyy"
                            value={dateRange.startDate && dateRange.endDate ? [dateRange.startDate, dateRange.endDate] : null}
                            onChange={handleSelect}
                            isoWeek={appSettings.weekStartDay === 'Monday'}
                          />
                        </div>
                      </div>
                    </div>
                  )}
                </div>
                <div className="invo-date-issueme">
                  <div className="invo-date-issue-tile">Issue Date</div>
                  {isMobile ? (
                    <div className="mobile-date-field" ref={issueDateRef} onClick={() => setIssueCalendarOpen(true)}>
                      <span className="mobile-date-val">{formatDateStr(issueDate)}</span>
                      <svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="#6366F1" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
                        <rect x="3" y="4" width="18" height="18" rx="2" ry="2"></rect>
                        <line x1="16" y1="2" x2="16" y2="6"></line>
                        <line x1="8" y1="2" x2="8" y2="6"></line>
                        <line x1="3" y1="10" x2="21" y2="10"></line>
                      </svg>
                      <div style={{ opacity: 0, height: 0, overflow: 'hidden', position: 'absolute', pointerEvents: 'none' }}>
                        <DatePicker
                          open={issueCalendarOpen}
                          onClose={() => setIssueCalendarOpen(false)}
                          oneTap
                          format="dd/MM/yyyy"
                          value={moment(moment.tz(issueDate, global.config.getTimeZone()).format('YYYY-MM-DD')).startOf("day").toDate()}
                          onChange={(val) => {
                            if (val) handleIssueDateChange(val);
                            setIssueCalendarOpen(false);
                          }}
                          placement="auto"
                          isoWeek={appSettings?.weekStartDay === 'Monday'}
                        />
                      </div>
                    </div>
                  ) : (
                    <div className="invo-date-due-cal">
                      <div className="calender-date-due-pic" ref={issueDateRef}>
                        <div className="date-picker-outer date-picker-outer-all">
                          <div className="custoom-icon-calender custoom-icon-calender-all">
                            <DatePicker
                              ref={issuePickerRef}
                              oneTap
                              format="dd/MM/yyyy"
                              value={moment(moment.tz(issueDate, global.config.getTimeZone()).format('YYYY-MM-DD')).startOf("day").toDate()}
                              onChange={handleIssueDateChange}
                              placement="auto"
                              required
                              isoWeek={appSettings.weekStartDay === 'Monday'}
                              caretAs={CalendarIcon}
                            />
                          </div>
                        </div>
                      </div>
                    </div>
                  )}
                </div>
                <div className="date-due-manual-edm">
                  <div className="invo-date-issue-tile also-for-dued-cal">
                    Due Date
                  </div>
                  {isMobile ? (
                    <div className="mobile-date-field" ref={dueDateRef} onClick={() => setDueCalendarOpen(true)}>
                      <span className="mobile-date-val">{formatDateStr(dueDate)}</span>
                      <svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="#6366F1" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
                        <rect x="3" y="4" width="18" height="18" rx="2" ry="2"></rect>
                        <line x1="16" y1="2" x2="16" y2="6"></line>
                        <line x1="8" y1="2" x2="8" y2="6"></line>
                        <line x1="3" y1="10" x2="21" y2="10"></line>
                      </svg>
                      <div style={{ opacity: 0, height: 0, overflow: 'hidden', position: 'absolute', pointerEvents: 'none' }}>
                        <DatePicker
                          open={dueCalendarOpen}
                          onClose={() => setDueCalendarOpen(false)}
                          oneTap
                          format="dd/MM/yyyy"
                          value={dueDate}
                          onChange={(val) => {
                            if (val) handleDueDateChange(val);
                            setDueCalendarOpen(false);
                          }}
                          placement="auto"
                          isoWeek={appSettings?.weekStartDay === 'Monday'}
                        />
                      </div>
                    </div>
                  ) : (
                    <div className="invo-date-due-cal">
                      <div className="calender-date-due-pic" ref={dueDateRef}>
                        <div className="date-picker-outer date-picker-outer-all">
                          <div className="custoom-icon-calender custoom-icon-calender-all">
                            <DatePicker
                              ref={duePickerRef}
                              oneTap
                              ranges={ranges}
                              format="dd/MM/yyyy"
                              value={dueDate}
                              onChange={handleDueDateChange}
                              placement="bottomEnd"
                              required
                              isoWeek={appSettings.weekStartDay === 'Monday'}
                              caretAs={CalendarIcon}
                            />
                          </div>
                        </div>
                      </div>
                    </div>
                  )}
                </div>

              </div>
            </div>
            <div className="sheed-sec-after-headem">
              <div className="tooltip-boxmain">
                {showTooltip && (
                  <Tooltip
                    className="custom-tooltip"
                    content={[
                      {
                        heading: "Regular Invoice",
                        content:
                          "Records the products or services delivered, the total amount due, and preferred payment method",
                        headingClass: "heading1tool",
                        contentClass: "content1tool",
                      },
                      {
                        heading: "Reinbursement Invoice",
                        content:
                          "Used when the subject is paid back for expenses.",
                        headingClass: "heading1tool second-toolhead",
                        contentClass: "content1tool",
                      },
                    ]}
                  />
                )}
              </div>
              <div className="inp-sec2-with2">
                <div className="input-field-inof">
                  <label htmlFor="invoice-title">User Name</label>
                  {!userName ? (
                    <div
                      style={{
                        height: "40px",
                        backgroundColor: "#e5e7eb",
                        border: "0.5px solid #b4b4b4",
                        borderRadius: "5px",
                        paddingLeft: "20px",
                        display: "flex",
                        alignItems: "center",
                        animation: "pulse 1.5s ease-in-out infinite",
                      }}
                    >
                      <div
                        style={{
                          width: "150px",
                          height: "18px",
                          backgroundColor: "rgba(255, 255, 255, 0.6)",
                          borderRadius: "4px",
                          animation: "pulse 1.5s ease-in-out infinite",
                        }}
                      />
                    </div>
                  ) : (
                    <input
                      type="text"
                      id="user-name"
                      placeholder="Enter User Name"
                      name="user-name"
                      value={userName}
                      className="read-only-input"
                      required
                      readOnly
                    />
                  )}
                </div>
                <div className={`input-field-inof ${userId && userId?.user_wx_comapny?.wx_company === "Any" ? "inline-section" : ""}`}>
                  {userId && userId?.user_wx_comapny?.wx_company === "Any" && (
                    <div className="type-dropdown-em">

                      <label htmlFor="bank-account">Company</label>
                      <div className="custom-dropdown">
                        {userWiseProfile?.length > 0 ? (
                          <div ref={companyeDropdownRef}
                            className={`custom-dropdown-user-new-outer custom-dropdown-select ${companyDropdownOpen ? 'open' : ''}`}
                          >
                            <div className="selected-option custom-dropdown-user-new" onClick={handleCompanyToggleDropdown}>
                              <span>{wxCompany && wxCompany !== 'Any' ? wxCompany : 'Select Company'}</span>
                              <svg width="18" height="9" viewBox="0 0 18 9" fill="none" xmlns="http://www.w3.org/2000/svg" className="type-dropdown-arrow-icon dropdown-chevron-icon" aria-hidden="true">
                                <path d="M1.5 1.5L9 7.5L16.5 1.5" stroke="#405BFF" strokeWidth="1.2" strokeLinecap="round" strokeLinejoin="round"/>
                              </svg>
                            </div>
                            {companyDropdownOpen && (
                              <div className="custom-dropdown-new">
                                <ul className="type-list">
                                  {userWiseProfile?.length > 0 &&
                                    userWiseProfile.map((item) => (
                                      <li
                                        key={item._id}
                                        className={wxCompany === item.wx_company ? 'selected-item' : ''}
                                        onClick={() => handleCompanySelect(item)}
                                      >
                                        {item.wx_company}
                                      </li>
                                    ))}
                                </ul>
                              </div>
                            )}
                          </div>
                        ) : (
                          <div className="no-company-message">
                            No Company is linked to this account.{' '}
                            <button onClick={addCompany}>Click here to add one.</button>
                          </div>
                        )}
                        <span className="custom-arrow"></span>
                      </div>
                    </div>
                  )}
                  <Modal
                    className="delete-modal"
                    isOpen={wiseModalIsOpen}
                    onRequestClose={closeWiseModal}
                    contentLabel="No Wise Account Modal"
                    style={{
                      content: {
                        height: "41%",
                        width: "30%",
                        position: "fixed",
                        top: "40%",
                        left: "50%",
                        parent: document.querySelector(".admin-outer.time.tracker"),
                      },
                    }}
                  >
                    <div className="delete-modal-content">
                      <div className="outter-modal-main">
                        <a className="close-image-clr1" onClick={closeWiseModal}>
                          <img src={crssrImage} alt="Close Icon" />{" "}
                        </a>
                      </div>
                      <h2>No Wise Account Registered</h2>
                      <p>
                        There is no Wise account registered for this account. Please add a Wise account to proceed further.
                      </p>
                      {isWiseProfileLoading ? (
                        <div className="delete-modal-buttons">
                          <div
                            style={{
                              width: "150px",
                              height: "44px",
                              backgroundColor: "#e5e7eb",
                              borderRadius: "6px",
                              animation: "pulse 1.5s ease-in-out infinite",
                            }}
                          />
                          <div
                            style={{
                              width: "100px",
                              height: "44px",
                              backgroundColor: "#e5e7eb",
                              borderRadius: "6px",
                              animation: "pulse 1.5s ease-in-out infinite",
                            }}
                          />
                        </div>
                      ) : (
                        <div className="delete-modal-buttons">
                          {(user.userType === userTypeConsts.SUPER_ADMIN || user.userType === userTypeConsts.ADMIN) && (
                            <button className="buttons-approved" onClick={goToWisePage}>
                              Add Wise Account
                            </button>
                          )}
                          <button onClick={closeWiseModal}>Close</button>
                        </div>
                      )}
                    </div>
                  </Modal>
                  {isBankLoading ? (
                    <div
                      className="custom-dropdown-user-new-outer"
                      style={{
                        pointerEvents: "none",
                        cursor: "default",
                        position: "relative",
                        width: "100%",
                      }}
                    >
                      <label htmlFor="bank-account">Bank Account </label>
                      <div
                        className="custom-dropdown-user-new"
                        style={{
                          backgroundColor: "#e5e7eb",
                          border: "0.2px solid rgba(106, 121, 136, 0.7)",
                          borderRadius: "7px",
                          width: "100%",
                          height: "43px",
                          paddingLeft: "16px",
                          paddingRight: "40px",
                          display: "flex",
                          alignItems: "center",
                          animation: "pulse 1.5s ease-in-out infinite",
                          boxSizing: "border-box",
                          position: "relative",
                          backgroundImage: "none",
                        }}
                      >
                        <span
                          style={{
                            width: "150px",
                            height: "19px",
                            backgroundColor: "rgba(255, 255, 255, 0.6)",
                            borderRadius: "4px",
                            animation: "pulse 1.5s ease-in-out infinite",
                            display: "inline-block",
                          }}
                        />
                      </div>
                    </div>
                  ) : isBankError ? (
                    <div className="error-message">
                      <p>Error loading bank accounts: {bankError?.message || 'Unknown error'}</p>
                      <button onClick={() => refetchBanks()}>Retry</button>
                    </div>
                  ) : (
                    <>
                      {bankDetails.length > 0 && (wiseProfile || wiseSettingsId) ? (
                        <div
                          ref={bankAccountDropdownRef}
                          className="custom-dropdown-user-new-outer"
                        >
                          <label htmlFor="bank-account">Bank Account </label>

                          <div
                            className="selected-option custom-dropdown-user-new"
                            onClick={handleToggleDropdown}
                            ref={bankRef}
                            // role="button"
                            // aria-expanded={!!bankAccountDropdownOpen}
                            // tabIndex={0}
                            // onKeyDown={(e) => {
                            //   if (e.key === "Enter" || e.key === " ") handleToggleDropdown();
                            // }}
                          >
                            <span>{getBankDisplayText(selectedBank)}</span>
                            <svg width="18" height="9" viewBox="0 0 18 9" fill="none" xmlns="http://www.w3.org/2000/svg" className="type-dropdown-arrow-icon dropdown-chevron-icon" aria-hidden="true">
                              <path d="M1.5 1.5L9 7.5L16.5 1.5" stroke="#405BFF" strokeWidth="1.2" strokeLinecap="round" strokeLinejoin="round"/>
                            </svg>
                          </div>

                          {bankAccountDropdownOpen && (
                            <div className="custom-dropdown-new" role="listbox">
                              {autoCurrencyFilteredBankDetails.length > 0 ? (
                                <>
                                  <input
                                    type="text"
                                    className="search-bar"
                                    placeholder="Search..."
                                    value={searchBankAccountTerm}
                                    onChange={handleSearchInputChange}
                                  />
                                  <ul className="bank-account-list">
                                    {filteredBankDetails?.length > 0 ? (
                                      filteredBankDetails.map((bank) => {
                                        const key = `${bank.id}_${bank.currency}`;
                                        const isSelected = invoiceBankListName === key;

                                        const acct = bank?.details?.accountNumber || "";
                                        const iban = bank?.details?.IBAN || "";
                                        const spacer = acct && iban ? " " : "";
                                        const label = `${acct}${spacer}${iban} (${bank.currency})`;

                                        return (
                                          <li
                                            key={key}
                                            className={isSelected ? "selected-item" : ""}
                                            onClick={() => handleSelectOption(key)}
                                            role="option"
                                            aria-selected={isSelected}
                                          >
                                            {label}
                                          </li>
                                        );
                                      })
                                    ) : (
                                      <li>No results found</li>
                                    )}
                                  </ul>
                                </>
                              ) : (
                                <div>
                                  No bank accounts available in the preferred currency
                                  <a onClick={(e) => { e.preventDefault(); let profileUrl; if (user.userType === userTypeConsts.SUPER_ADMIN || user.userType === userTypeConsts.ADMIN) { console.log('selUser:', selUser); console.log('invoice.selectedUser:', invoice.selectedUser); if (!selUser && invoice.selectedUser && invoice.selectedUser[1]) { setSelUser(invoice.selectedUser[1]); } const userId = selUser || (invoice.selectedUser && invoice.selectedUser[1]); if (!userId) { alert('User ID not available. Please try again.'); return; } const encryptedId = AES.encrypt(userId, 'encryptionKey').toString(); const encodedId = encodeURIComponent(encryptedId).replace(/\//g, '%2F'); profileUrl = `${window.location.origin}/user/profile/${encodedId}?openBankAccount=true`; } else { profileUrl = `${window.location.origin}/user/profile/settings?openBankAccount=true`; } window.open(profileUrl, '_blank'); }}>
                                    Click here to add one.
                                  </a>
                                </div>
                              )}
                            </div>
                          )}
                        </div>
                      ) : (
                        <>
                          {(bankDetails.length === 0 && userName && (wiseProfile || wiseSettingsId)) && (
                            <>
                              <div className="no-acccount-link">
                                <label>Bank Account </label>
                                No bank account is linked to this account.{" "}
                                <a onClick={(e) => { e.preventDefault(); let profileUrl; if (user.userType === userTypeConsts.SUPER_ADMIN || user.userType === userTypeConsts.ADMIN) { console.log('selUser:', selUser); console.log('invoice.selectedUser:', invoice.selectedUser); if (!selUser && invoice.selectedUser && invoice.selectedUser[1]) { setSelUser(invoice.selectedUser[1]); } const userId = selUser || (invoice.selectedUser && invoice.selectedUser[1]); if (!userId) { alert('User ID not available. Please try again.'); return; } const encryptedId = AES.encrypt(userId, 'encryptionKey').toString(); const encodedId = encodeURIComponent(encryptedId).replace(/\//g, '%2F'); profileUrl = `${window.location.origin}/user/profile/${encodedId}?openBankAccount=true`; } else { profileUrl = `${window.location.origin}/user/profile/settings?openBankAccount=true`; } window.open(profileUrl, '_blank'); }}>
                                  Click here to add one.
                                </a>
                              </div>

                              <Modal
                                className="delete-modal"
                                isOpen={modalIsOpen}
                                onRequestClose={closeModal}
                                contentLabel="Approve Modal"
                                style={{
                                  content: {
                                    height: "41%",
                                    width: "30%",
                                    position: "fixed",
                                    top: "40%",
                                    left: "50%",
                                    parent: document.querySelector(".admin-outer.time.tracker"),
                                  },
                                }}
                              >
                                <div className="delete-modal-content">
                                  <div className="outter-modal-main">
                                    <a className="close-image-clr1" onClick={closeModal}>
                                      <img src={crssrImage} alt="Close Icon" />{" "}
                                    </a>
                                  </div>
                                  <h2>No Bank Registered</h2>
                                  <p>
                                    No Bank Registered in this Account
                                    Please add a bank account to proceed further
                                  </p>
                                  {isBankLoading ?
                                    (
                                      <div className="delete-modal-buttons">
                                        <div
                                          style={{
                                            width: "120px",
                                            height: "44px",
                                            backgroundColor: "#e5e7eb",
                                            borderRadius: "6px",
                                            animation: "pulse 1.5s ease-in-out infinite",
                                          }}
                                        />
                                        <div
                                          style={{
                                            width: "100px",
                                            height: "44px",
                                            backgroundColor: "#e5e7eb",
                                            borderRadius: "6px",
                                            animation: "pulse 1.5s ease-in-out infinite",
                                          }}
                                        />
                                      </div>
                                    )
                                    : (
                                      <div className="delete-modal-buttons">
                                        <button
                                          className="buttons-approved"
                                          onClick={addBank}
                                          disabled={isBankLoading}
                                        >
                                          Add Bank
                                        </button>

                                        <button onClick={closeModal}>
                                          Cancel
                                        </button>
                                      </div>
                                    )
                                  }
                                </div>
                              </Modal>
                            </>
                          )}
                        </>
                      )}
                    </>
                  )}
                  {bankIsValid && (
                    <span className="text-red-500 text-xs italic">
                      Bank Details Cannot be empty
                    </span>
                  )}
                </div>
              </div>
              <div className="inp-sec2-with2 inp-sec2-with2-one">
                <div className="input-field-inof">
                  <label htmlFor="invoice-title">Invoice Title</label>
                  <input
                    type="text"
                    id="invoice-title"
                    placeholder="Enter invoice Title"
                    name="invoice-title"
                    onChange={(e) => setTitle(e.target.value)}
                    value={title}
                    required
                    className={titleIsValid ? "input-validation-error" : ""}
                    ref={titleRef}
                  />
                  {titleIsValid && (
                    <span className="text-red-500 text-xs italic">
                      Title Cannot be empty
                    </span>
                  )}
                </div>
              </div>
              {isMobile ? (
                <div className="mobile-line-items-section" style={{ borderTop: '1px solid #EEF2F6', paddingTop: '20px', marginTop: '20px' }}>
                  <div className="mobile-line-items-header" style={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between', padding: '0 20px 16px 20px' }}>
                    <h3 className="mobile-line-items-title" style={{ fontSize: '18px', fontWeight: '700', color: '#1E293B', margin: 0 }}>Line Items</h3>
                    <button
                      type="button"
                      className="add-item-button"
                      onClick={(e) => {
                        e.preventDefault();
                        setNewLineModalOpen(true);
                      }}
                    >
                      <img src={addicoplus} alt="addicon" /> Add Item
                    </button>
                  </div>
                  {productDetails.some(p => p.description || p.cost || (p.amount && p.amount !== "00.00" && p.amount !== "0.00")) && (
                    <div className="mobile-line-items-list" style={{ padding: '0 20px 8px 20px' }}>
                      {productDetails.map((product, index) => {
                        if (!(product.description || product.cost || (product.amount && product.amount !== "00.00" && product.amount !== "0.00"))) {
                          return null;
                        }
                        return (
                          <div key={index} className="mobile-line-item-card" style={{ background: '#F8FAFC', border: '1px solid #E2E8F0', borderRadius: '12px', padding: '14px 16px', marginBottom: '10px', display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>
                            <div>
                              <div style={{ fontSize: '15px', fontWeight: '600', color: '#1E293B' }}>{product.description || "Line Item"}</div>
                              <div style={{ fontSize: '13px', color: '#64748B', marginTop: '4px' }}>
                                Cost: ${product.cost || "0"} | VAT: {product.vat || "0"}%
                              </div>
                            </div>
                            <div style={{ display: 'flex', alignItems: 'center', gap: '12px' }}>
                              <span style={{ fontSize: '15px', fontWeight: '700', color: '#1E293B' }}>${product.amount || "0.00"}</span>
                              <button
                                type="button"
                                style={{ background: 'none', border: 'none', cursor: 'pointer', padding: '4px' }}
                                onClick={() => handleRemoveRow(index)}
                              >
                                <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="#000" strokeWidth="2">
                                  <polyline points="3 6 5 6 21 6"></polyline>
                                  <path d="M19 6v14a2 2 0 0 1-2 2H7a2 2 0 0 1-2-2V6m3 0V4a2 2 0 0 1 2-2h4a2 2 0 0 1 2 2v2"></path>
                                </svg>
                              </button>
                            </div>
                          </div>
                        );
                      })}
                    </div>
                  )}
                </div>
              ) : (
                invType === 'Regular' ? (
                <div className="detail-add-parteditmanual mobile-dropdown-outer">
                  <table className="invoice-table-editmanual">
                    <thead className="the-abantant-edittxh">
                      <tr>
                        <th>Description</th>
                        <th>Cost</th>
                        <th>VAT %</th>
                        <th>Amount</th>
                      </tr>
                    </thead>
                    <tbody>
                      {productDetails.map((product, index) => (
                        <tr key={index}>
                          <td className="description-manual mobile-dropdown">
                            <div className="mobile-hide">
                              <input
                                type="text"
                                list="projectOptions"
                                value={product.description}
                                name="description"
                                onChange={(e) => handleInputChange(e, index, "description")}
                                required
                                className={descriptionIsValid ? "input-validation-error" : ""}
                                placeholder="Description"
                                ref={descriptionRef}
                                autoComplete="off"
                              />
                            </div>
                            {selUserCategory !== userCategory.Vendor && (
                              <>
                                <div className="desktop-hide">
                                  <div className="custom-dropdown">
                                    <div
                                      ref={(el) => (dropdownRefs.current[index] = el)}
                                      className={`custom-dropdown-user-new-outer custom-dropdown-select ${dropdownOpenStates[index] ? 'open' : ''} ${descriptionIsValid ? 'input-validation-error' : ''}`}
                                      onClick={() => toggleDropdown(index)}
                                    >
                                      <div className="selected-option custom-dropdown-user-new">
                                        {selectedProjects[index]}
                                      </div>
                                    </div>
                                    {dropdownOpenStates[index] && (
                                      <div className="custom-dropdown-new">
                                        <ul className="project-list">
                                          {projectId
                                            .slice()
                                            .sort((a, b) => a.project_name?.toLowerCase().localeCompare(b.project_name?.toLowerCase()))
                                            .map((project) => (
                                              <li key={project._id} onClick={() => selectProjectOption(project, index)}>
                                                {project.project_name}
                                              </li>
                                            ))}
                                        </ul>
                                      </div>
                                    )}
                                    <span className="custom-arrow"></span>
                                  </div>
                                </div>
                                <div className="mobile-hide">
                                  <datalist id="projectOptions" style={{ position: 'absolute', top: '20%', left: 0 }}>
                                    <option value="">Select Project</option>
                                    {projectId
                                      .slice()
                                      .sort((a, b) => a.project_name?.toLowerCase().localeCompare(b.project_name?.toLowerCase()))
                                      .map((project) => (
                                        <option
                                          key={project._id}
                                          value={project.project_name}
                                        >
                                          {project.project_name}
                                        </option>
                                      ))}
                                  </datalist>
                                </div>
                              </>
                            )}
                          </td>
                          <td className="edit-manual-costtr">
                            <input
                              type="number"
                              step="any"
                              data-message="Please add Cost"
                              name="cost"
                              min="0"
                              data-no={index + 1}
                              required
                              placeholder="Cost"
                              onChange={(e) =>
                                handleInputChange(e, index, "cost")
                              }
                              className={costIsValid ? "input-validation-error" : ""}
                              value={product.cost}
                              ref={costRef}
                              onWheel={numberInputOnWheelPreventChange}
                            />
                          </td>
                          <td className="editmanual-vattd">
                            <input
                              type="number"
                              step="any"
                              data-message="Please add VAT"
                              name="vat"
                              min="0"
                              data-no={index + 1}
                              required
                              placeholder="VAT %"
                              onChange={(e) => handleInputChange(e, index, "vat")}
                              className={taxIsValid ? "input-validation-error" : ""}
                              value={product.vat}
                              ref={taxRef}
                              onWheel={numberInputOnWheelPreventChange}
                            />
                          </td>
                          <td className="editmanual-amount-tr">
                            <div className="amount-cell">
                              <div className="amount-display-wrapper">
                                {invoiceBankCurrency ? (
                                  <>
                                    {product.amount ? (
                                      <>
                                        {new Intl.NumberFormat("en-US", {
                                          style: "currency",
                                          currency: invoiceBankCurrency,
                                        }).format(product.amount)}
                                      </>
                                    ) : (
                                      <>
                                        {new Intl.NumberFormat("en-US", {
                                          style: "currency",
                                          currency: invoiceBankCurrency,
                                        }).format("00.00")}
                                      </>
                                    )}
                                  </>
                                ) : (
                                  <>
                                    {product.amount ? (
                                      <span>{product.amount}</span>
                                    ) : (
                                      <span>00.00</span>
                                    )}
                                  </>
                                )}
                                {productDetails.length !== 1 && (
                                  <button 
                                    className="del-icon-main-sel"
                                    type="button"
                                    onClick={(e) => {
                                      e.preventDefault();
                                      e.stopPropagation();
                                      handleRemoveRow(index);
                                    }}
                                  >
                                    <img src={dletImage} alt="delete-icon" />
                                  </button>
                                )}
                              </div>
                            </div>
                          </td>
                        </tr>
                      ))}
                    </tbody>
                  </table>
                  <button
                    type="button"
                    className="add-item-button"
                    onClick={(e) => {
                      if (window.innerWidth <= 991) {
                        e.preventDefault();
                        setNewLineModalOpen(true);
                      } else {
                        handleAddRow(e);
                      }
                    }}
                  >
                    <img src={addicoplus} alt="addicon" /> Add Item
                  </button>
                </div>)
                :
                (<div className="detail-add-parteditmanual">
                  <table className="invoice-table-editmanual">
                    <thead className="the-abantant-edittxh">
                      <tr>
                        <th>Descriptions</th>
                        <th>Category</th>
                        <th>VAT %</th>
                        <th>Cost</th>
                        <th>Amount</th>
                      </tr>
                    </thead>
                    <tbody>
                      {productDetails.map((product, index) => (
                        <tr key={index}>
                          <td className="description-manual">
                            <input
                              type="text"
                              data-message="Please add Description"
                              name="description"
                              required
                              placeholder="Description"
                              onChange={(e) =>
                                handleInputChange(e, index, "description")
                              }
                              className={descriptionIsValid ? "input-validation-error" : ""}
                              value={product.description}
                              ref={descriptionRef}
                            />
                          </td>
                          <td className="description-manual">

                            <select
                              type="select"
                              value={product.expenseCategory}
                              name="expenseCategory"
                              onChange={(e) =>
                                handleInputChange(e, index, "expenseCategory")
                              }
                              required
                              className={expenseCategoryIsValid ? "input-validation-error" : ""}
                              placeholder="Expense Category"
                              ref={descriptionRef}
                            >
                              <option value="">Select Category</option>
                              {expenseCategory
                                ?.slice()
                                .sort((a, b) => a.exp_category_name?.toLowerCase().localeCompare(b.exp_category_name?.toLowerCase()))
                                .map((expense) => (
                                  <option
                                    key={expense._id}
                                    value={expense.exp_category_name}
                                  >
                                    {expense.exp_category_name}
                                  </option>
                                ))}
                            </select>

                          </td>
                          <td className="editmanual-vattd">
                            <input
                              type="number"
                              step="any"
                              data-message="Please add VAT"
                              name="vat"
                              min="0"
                              data-no={index + 1}
                              required
                              placeholder="VAT %"
                              onChange={(e) => handleInputChange(e, index, "vat")}
                              className={taxIsValid ? "input-validation-error" : ""}
                              value={product.vat}
                              ref={taxRef}
                              onWheel={numberInputOnWheelPreventChange}
                            />
                          </td>
                          <td className="edit-manual-costtr">
                            <input
                              type="number"
                              step="any"
                              data-message="Please add Cost"
                              name="cost"
                              min="0"
                              data-no={index + 1}
                              required
                              placeholder="Cost"
                              onChange={(e) =>
                                handleInputChange(e, index, "cost")
                              }
                              className={costIsValid ? "input-validation-error" : ""}
                              value={product.cost}
                              ref={costRef}
                              onWheel={numberInputOnWheelPreventChange}
                            />
                          </td>

                          <td className="editmanual-amount-tr">
                            <div className="amount-cell">
                              <div className="amount-display-wrapper">
                                {invoiceBankCurrency ? (
                                  <>
                                    {product.amount ? (
                                      <>
                                        {new Intl.NumberFormat("en-US", {
                                          style: "currency",
                                          currency: invoiceBankCurrency,
                                        }).format(product.amount)}
                                      </>
                                    ) : (
                                      <>
                                        {new Intl.NumberFormat("en-US", {
                                          style: "currency",
                                          currency: invoiceBankCurrency,
                                        }).format("00.00")}
                                      </>
                                    )}
                                  </>
                                ) : (
                                  <>
                                    {product.amount ? (
                                      <span>{product.amount}</span>
                                    ) : (
                                      <span>00.00</span>
                                    )}
                                  </>
                                )}
                                {productDetails.length !== 1 && (
                                  <button 
                                    className="del-icon-main-sel"
                                    type="button"
                                    onClick={(e) => {
                                      e.preventDefault();
                                      e.stopPropagation();
                                      handleRemoveRow(index);
                                    }}
                                  >
                                    <img src={dletImage} alt="delete-icon" />
                                  </button>
                                )}
                              </div>
                            </div>
                          </td>
                        </tr>
                      ))}
                    </tbody>
                  </table>
                  <button className="add-item-button" onClick={handleAddRow}>
                    <img src={addicoplus} alt="addicon" /> Add Item
                  </button>
                </div>
                )
              )}
            </div>
            <div className="sec-after-tab-ls-part">
              <div className="sec-withother-and-add">

                <div className="other-secp1">
                  <div className="other-head1">Other comments</div>
                  <div className="other-subhead1">
                    <textarea
                      type="text"
                      className=""
                      placeholder="Other Comments"
                      value={otherComnt}
                      onChange={(e) => setOtherComnt(e.target.value)}
                      style={{ resize: "none" }}
                    ></textarea>
                  </div>
                </div>

                <div className="file-add-p1-attachment">
                  <div className="attachment-head">Attachments</div>
                  <div className="style-portion-browsetext" style={{ cursor: 'pointer' }}>
                    <label className="add-item-button-end-browse">
                      <img src={addicoplus} alt="addicon" /> Browse
                      <input
                        ref={fileInputRef}
                        type="file"
                        style={{ display: 'none' }}
                        onChange={handleInvDocChange}
                        multiple // Allow multiple file selection
                      />
                    </label>
                    <div className="upload-file-name-br">
                      {invFiles.map((file, index) => (
                        <div key={index} className="uploaded-file-item">
                          <span>{file.name}</span>
                          <a onClick={() => removeFile(index)}>Remove</a>
                        </div>
                      ))}
                    </div>
                  </div>
                </div>
              </div>
              <div className="invo-total-specialcard">
                <div className="specialcard-outter">
                  <table className="to-ino-to-special">
                    <tbody>
                      <tr>
                        <th className="sub-lem-tb-fisl">Subtotal</th>
                        <td className="sub-price-tb-fisl">
                          {invoiceBankCurrency ? (
                            <>
                              {new Intl.NumberFormat("en-US", {
                                style: "currency",
                                currency: invoiceBankCurrency,
                              }).format(subTotal)}
                            </>
                          ) : (
                            <span>{subTotal}</span>
                          )}
                        </td>
                      </tr>
                      <tr>
                        <th className="sub-vat-tb-fisl">VAT</th>
                        <td className="sub-vatpr-tb-fisl">
                          {invoiceBankCurrency ? (
                            <>
                              {new Intl.NumberFormat("en-US", {
                                style: "currency",
                                currency: invoiceBankCurrency,
                              }).format(taxTotal)}
                            </>
                          ) : (
                            <span>{taxTotal}</span>
                          )}
                        </td>
                      </tr>
                      <tr>
                        <th className="sub-invoto-tb-fisl">Invoice Total</th>
                        <td className="sub-ivvoto-price-tb-fisl">
                          {invoiceBankCurrency ? (
                            <>
                              {new Intl.NumberFormat("en-US", {
                                style: "currency",
                                currency: invoiceBankCurrency,
                              }).format(total)}
                            </>
                          ) : (
                            <span>{total}</span>
                          )}
                        </td>
                      </tr>
                    </tbody>
                  </table>
                  {bankDetails.length > 0 && navigator.onLine && (
                    isMobile ? (
                      <div className="mobile-submit-bar-wrapper">
                        <a
                          className="largecreate-invo-btn1"
                          onClick={openPaymentModal}
                        >
                          {isLoading ? (
                            <div
                              style={{
                                width: "120px",
                                height: "18px",
                                backgroundColor: "rgba(255, 255, 255, 0.6)",
                                borderRadius: "4px",
                                animation: "pulse 1.5s ease-in-out infinite",
                                margin: "0 auto",
                              }}
                            />
                          ) : "Submit Invoice"}
                        </a>
                      </div>
                    ) : (
                      <a
                        className="largecreate-invo-btn1"
                        onClick={openPaymentModal}
                      >
                        {isLoading ? (
                          <div
                            style={{
                              width: "120px",
                              height: "18px",
                              backgroundColor: "rgba(255, 255, 255, 0.6)",
                              borderRadius: "4px",
                              animation: "pulse 1.5s ease-in-out infinite",
                              margin: "0 auto",
                            }}
                          />
                        ) : "Create Invoice"}
                      </a>
                    )
                  )}
                </div>
              </div>
            </div>
          </div>
        </div>
        <div>
          <Modal
            className="delete-modal"
            isOpen={showWxCompanyModal}
            onRequestClose={closeWXCompanyModal}
            contentLabel="Payment"
            style={{
              content: {
                height: "41%",
                width: "30%",
                position: "fixed",
                top: "40%",
                left: "50%",
                parent: document.querySelector(".admin-outer.time.tracker"),
              },
            }}
          >
            <div className="delete-modal-content">
              <div className="outter-modal-main">
                <a className="close-image-clr1" onClick={closeWXCompanyModal}>
                  <img src={crssrImage} alt="Close Icon" />{" "}
                </a>
              </div>
              <h2>Select Wise Account</h2>
              <p>Select Wise Account to Create this Invoice?</p>
              <div className="form-field-payment">
                <label htmlFor="client" className="form-label">
                  Select Wise Account
                </label>
                <select
                  required
                  onChange={(e) => {
                    const selected = userWiseProfile?.find((item) => item.wx_company === e.target.value);
                    if (selected) handleCompanySelect(selected);
                  }}
                  className="form-select"
                  value={wxCompany || ""}
                >
                  <option value="">Select Wise Account</option>

                  {userWiseProfile?.length > 0 &&
                    userWiseProfile?.map((item, index) => {
                      return (
                        <option key={item._id || index} value={item.wx_company}>
                          {item.wx_company}
                        </option>
                      );
                    })}
                </select>
              </div>

              <div className="delete-modal-buttons paynow-invoice-sec">

                {bankDetails.length > 0 && invoice.selectedUser && wxCompany && wxCompany !== "Any" ? (
                  <button
                    className="buttons-submit"
                    type="submit"
                    onClick={handleSubmit}
                    disabled={isLoading}
                  >
                    {isLoading ? (
                      <div
                        style={{
                          width: "120px",
                          height: "18px",
                          backgroundColor: "rgba(255, 255, 255, 0.6)",
                          borderRadius: "4px",
                          animation: "pulse 1.5s ease-in-out infinite",
                          margin: "0 auto",
                        }}
                      />
                    ) : (
                      "Create Invoice"
                    )}
                  </button>
                ) : (
                  <button
                    className="buttons-pay buttons-pay-disabled"
                    disabled
                  >
                    Create Invoice
                  </button>
                )}
                <button
                  className="buttons-pay-cancel"
                  onClick={closeWXCompanyModal}
                >
                  Cancel
                </button>
              </div>
            </div>
          </Modal>

          <Modal
            isOpen={newLineModalOpen}
            onRequestClose={() => setNewLineModalOpen(false)}
            className="new-item-modal"
            overlayClassName="mobile-sheet-overlay"
            contentLabel="New Line Item"
            closeTimeoutMS={480}
          >
            <div className="modal">
              <div className="mobile-bottom-sheet-header">
                <button
                  type="button"
                  className="mobile-sheet-close-circle"
                  onClick={() => setNewLineModalOpen(false)}
                >
                  <svg width="12" height="12" viewBox="0 0 12 12" fill="none" xmlns="http://www.w3.org/2000/svg">
                    <path d="M1 1L11 11M1 11L11 1" stroke="#334155" strokeWidth="1.8" strokeLinecap="round" strokeLinejoin="round"/>
                  </svg>
                </button>
                <h3 className="mobile-sheet-title">New Line Item</h3>
              </div>
              <form onSubmit={handleAddLineItemSubmit} className="mobile-new-line-form" style={{ padding: '20px 24px' }}>
                <div className="form-group-1modal" style={{ paddingBottom: '16px' }}>
                  <label style={{ display: 'block', fontSize: '14px', fontWeight: '500', color: '#64748B', marginBottom: '8px' }}>Description</label>
                  <input
                    type="text"
                    placeholder="Write here"
                    value={newLineDesc}
                    onChange={(e) => setNewLineDesc(e.target.value)}
                    style={{ width: '100%', height: '48px', borderRadius: '12px', border: '1px solid rgb(226, 232, 240)', padding: '0px 16px', fontSize: '18px', fontWeight: 300, color: '#282828', boxSizing: 'border-box' }}
                  />
                </div>
                <div className="form-group-1modal" style={{ paddingBottom: '16px' }}>
                  <label style={{ display: 'block', fontSize: '14px', fontWeight: '500', color: '#64748B', marginBottom: '8px' }}>Cost</label>
                  <input
                    type="number"
                    placeholder="$"
                    value={newLineCost}
                    onChange={(e) => setNewLineCost(e.target.value)}
                    style={{ width: '100%', height: '48px', borderRadius: '12px', border: '1px solid rgb(226, 232, 240)', padding: '0px 16px', fontSize: '18px', fontWeight: 300, color: '#282828', boxSizing: 'border-box' }}
                  />
                </div>
                <div className="form-group-1modal" style={{ paddingBottom: '24px' }}>
                  <label style={{ display: 'block', fontSize: '14px', fontWeight: '500', color: '#64748B', marginBottom: '8px' }}>VAT%</label>
                  <input
                    type="number"
                    placeholder="$"
                    value={newLineVat}
                    onChange={(e) => setNewLineVat(e.target.value)}
                    style={{ width: '100%', height: '48px', borderRadius: '12px', border: '1px solid rgb(226, 232, 240)', padding: '0px 16px', fontSize: '18px', fontWeight: 300, color: '#282828', boxSizing: 'border-box' }}
                  />
                </div>
                <button
                  type="submit"
                  className="create-button modalsubmitbtn-1"
                  style={{ width: '100%', height: '48px', background: '#6479F8', borderRadius: '6px', color: '#FFFFFF', fontSize: '15px', fontWeight: '600', border: 'none', cursor: 'pointer', boxShadow: '0 4px 14px rgba(100, 121, 248, 0.35)' }}
                >
                  Add Line Item
                </button>
              </form>
            </div>
          </Modal>
        </div>
      </form>
      <style>{`
        @keyframes pulse {
          0%, 100% {
            opacity: 1;
          }
          50% {
            opacity: 0.5;
          }
        }
      `}</style>
    </div>
  );
};

export default InvoiceCreateManual;